<script setup lang="ts">
import { computed } from "vue";
import ChoosePlanPicker from "@/features/subscribe/ChoosePlanPicker.vue";
import ChoosePlanOptionFlat from "@/features/subscribe/ChoosePlanOptionFlat.vue";
import ChoosePlanOptionSkeletonFlat from "@/features/subscribe/ChoosePlanOptionSkeletonFlat.vue";
import ChoosePlanGuarantee from "@/features/subscribe/ChoosePlanGuarantee.vue";
import BaseText from "@/library/BaseText.vue";
import { usePostHogFeatureFlag } from "@/composables/usePostHogFeatureFlag.js";
import { PH_FEATURE_FLAG_TOP_OF_FUNNEL_EXPERIMENT } from "@/scripts/posthogEvents";

const {
  featureFlag: topOfFunnelFlag,
  hasLoadedFeatureFlag: topOfFunnelFlagLoaded,
} = usePostHogFeatureFlag(PH_FEATURE_FLAG_TOP_OF_FUNNEL_EXPERIMENT);

const showGuaranteeBelowPlanPicker = computed(
  () =>
    topOfFunnelFlagLoaded.value &&
    topOfFunnelFlag.value !== "checkout-guarantee-below-cta"
);

const monthlyPlansOnly = computed(
  () =>
    topOfFunnelFlagLoaded.value &&
    topOfFunnelFlag.value === "checkout-plans-monthly-only"
);
</script>

<template>
  <ChoosePlanPicker
    v-bind="$attrs"
    class="choose-plan-picker-flat"
    :monthly-only="monthlyPlansOnly"
  >
    <template #label>
      <BaseText
        as="h2"
        variant="headline-3-bold"
      >
        Select plan
      </BaseText>
    </template>
    <template #skeleton="{ selectedBillingCycle }">
      <ChoosePlanOptionSkeletonFlat
        type="individual"
        :billing="selectedBillingCycle"
        :monthly-only="monthlyPlansOnly"
      />
      <ChoosePlanOptionSkeletonFlat
        type="couple"
        :billing="selectedBillingCycle"
        :monthly-only="monthlyPlansOnly"
      />
      <ChoosePlanOptionSkeletonFlat
        type="family"
        :billing="selectedBillingCycle"
        :monthly-only="monthlyPlansOnly"
      />
    </template>
    <template #option="slotProps">
      <ChoosePlanOptionFlat
        v-bind="slotProps"
        :monthly-only="monthlyPlansOnly"
      />
    </template>
    <template #after>
      <ChoosePlanGuarantee
        v-show="showGuaranteeBelowPlanPicker"
        class="choose-plan-picker-flat__guarantee"
      />
    </template>
  </ChoosePlanPicker>
</template>

<style scoped lang="scss">
/* stylelint-disable */
.choose-plan-picker-flat {
  &__guarantee {
    margin-top: 16px;
  }

  :deep(.choose-plan-picker__billing-cycle) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  :deep(.choose-plan-picker__plans) {
    @media all and (max-width: $screen-lg) {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
}
</style>
